/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `pending` - pending
 * * `completed` - completed
 * * `failed` - failed
 * @export
 */
export const DemoRefreshStatusResponseStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type DemoRefreshStatusResponseStatusEnum = typeof DemoRefreshStatusResponseStatusEnum[keyof typeof DemoRefreshStatusResponseStatusEnum];


export function instanceOfDemoRefreshStatusResponseStatusEnum(value: any): boolean {
    for (const key in DemoRefreshStatusResponseStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(DemoRefreshStatusResponseStatusEnum, key)) {
            if (DemoRefreshStatusResponseStatusEnum[key as keyof typeof DemoRefreshStatusResponseStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DemoRefreshStatusResponseStatusEnumFromJSON(json: any): DemoRefreshStatusResponseStatusEnum {
    return DemoRefreshStatusResponseStatusEnumFromJSONTyped(json, false);
}

export function DemoRefreshStatusResponseStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoRefreshStatusResponseStatusEnum {
    return json as DemoRefreshStatusResponseStatusEnum;
}

export function DemoRefreshStatusResponseStatusEnumToJSON(value?: DemoRefreshStatusResponseStatusEnum | null): any {
    return value as any;
}

export function DemoRefreshStatusResponseStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DemoRefreshStatusResponseStatusEnum {
    return value as DemoRefreshStatusResponseStatusEnum;
}

